if (process.env.MARKETING_PUBLIC_PATH) {
  __webpack_public_path__ = process.env.MARKETING_PUBLIC_PATH;
}
